/* OCBON First Period Landing Page — JS
 * Loaded via ocbon-fp-scripts.liquid as an external asset.
 * Handles: subscribe toggle, size selector, ATC, FAQ accordion, smooth scroll, reveal.
 * IMPORTANT: Shopify strips 'id' attrs in sections — use classes + data-* only.
 */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ── Subscribe toggle ─────────────────────────────────────────── */
  function initSubscribeToggle() {
    const options = $$('.js-fp-sub-option');
    if (!options.length) return;

    const priceEl    = $('.js-fp-price');
    const compareEl  = $('.js-fp-compare');
    const saveEl     = $('.js-fp-save');
    const freqEl     = $('.js-fp-freq');
    const atcText    = $('.js-fp-atc-text');
    const planInput  = $('.js-fp-native-plan');

    options.forEach((btn) => {
      btn.addEventListener('click', () => {
        options.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const price        = btn.getAttribute('data-fp-price');
        const compare      = btn.getAttribute('data-fp-compare');
        const save         = btn.getAttribute('data-fp-save');
        const freq         = btn.getAttribute('data-fp-freq');
        const isSub        = btn.getAttribute('data-fp-sub') === 'subscribe';
        const sellingPlan  = btn.getAttribute('data-fp-selling-plan') || '';

        if (saveEl) {
          saveEl.textContent    = isSub ? save : '';
          saveEl.style.display  = isSub ? '' : 'none';
        }
        if (freqEl)  freqEl.textContent  = freq ? freq + ' · cancel anytime' : '';
        if (atcText) atcText.textContent = isSub ? 'Subscribe & Save →' : 'Add to Cart →';

        // Drive the native form's selling_plan hidden input
        if (planInput) planInput.value = isSub ? sellingPlan : '';

        // Recalculate displayed price for active bundle
        const activeBundle = $('.js-fp-bundle-btn.is-active');
        if (activeBundle) {
          updatePriceForBundle(activeBundle);
        } else {
          if (priceEl) priceEl.textContent = price;
          if (compareEl) {
            compareEl.textContent   = compare;
            // Only show strikethrough price on subscribe — one-time has no discount
            compareEl.style.display = isSub ? '' : 'none';
          }
        }

        // Also refresh all bundle card inner price spans
        updateAllBundleCardPrices();
      });
    });
  }

  /* ── Image gallery ────────────────────────────────────────────── */
  function swapMainImage(url) {
    const mainImg = $('.js-fp-main-img');
    if (!mainImg || !url) return;
    mainImg.classList.add('is-fading');
    setTimeout(() => {
      mainImg.src = url;
      mainImg.classList.remove('is-fading');
    }, 180);
  }

  function initGallery() {
    const thumbs = $$('.js-fp-thumb');
    if (!thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        swapMainImage(thumb.getAttribute('data-fp-img'));
      });
    });
  }

  /* ── Size selector ────────────────────────────────────────────── */
  function initSizeSelector() {
    const btns = $$('.js-fp-size');
    if (!btns.length) return;

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        btns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        // Update native form variant input so correct variant is added to cart
        const variantId = btn.getAttribute('data-fp-variant');
        if (variantId) {
          const nativeVariantInput = $('.js-fp-native-variant');
          if (nativeVariantInput) nativeVariantInput.value = variantId;
        }

        const img = btn.getAttribute('data-fp-img');
        if (img) {
          swapMainImage(img);
          // Sync first thumb to active size packshot
          const firstThumb = $('.js-fp-thumb');
          if (firstThumb) {
            $$('.js-fp-thumb').forEach((t) => t.classList.remove('is-active'));
            firstThumb.setAttribute('data-fp-img', img);
            firstThumb.querySelector('img').src = img;
            firstThumb.classList.add('is-active');
          }
        }

        // Refresh bundle card pad count labels for the new size
        updateBundlePadLabels();
      });
    });
  }

  /* ── Bundle selector ──────────────────────────────────────────── */
  function updatePriceForBundle(bundleBtn) {
    const priceEl   = $('.js-fp-price');
    const compareEl = $('.js-fp-compare');
    if (!bundleBtn) return;

    const qty     = parseInt(bundleBtn.getAttribute('data-fp-qty'), 10) || 1;
    const isSub   = !!$('.js-fp-sub-option.is-active[data-fp-sub="subscribe"]');

    if (qty === 1) {
      // Single pack — use the subscribe/one-time per-pack price from the active toggle
      const activeSub = $('.js-fp-sub-option.is-active');
      if (activeSub) {
        if (priceEl)   priceEl.textContent   = activeSub.getAttribute('data-fp-price');
        if (compareEl) compareEl.textContent  = activeSub.getAttribute('data-fp-compare');
      }
    } else {
      // Multi-pack
      if (isSub) {
        // Use the pre-calculated bundle subscribe total
        if (priceEl)   priceEl.textContent   = bundleBtn.getAttribute('data-fp-price');
        if (compareEl) compareEl.textContent  = bundleBtn.getAttribute('data-fp-compare');
      } else {
        // One-time: use pre-set one-time bundle price if available, else multiply per-pack
        const oncePrice = bundleBtn.getAttribute('data-fp-price-once');
        const activeSub  = $('.js-fp-sub-option.is-active');
        const cmpStr     = activeSub ? activeSub.getAttribute('data-fp-compare') : '';
        const cmpPack    = parseFloat((cmpStr || '').replace(/[^0-9.]/g, ''));
        if (priceEl)   priceEl.textContent   = oncePrice || ('$' + (parseFloat((activeSub ? activeSub.getAttribute('data-fp-price') : '0').replace(/[^0-9.]/g, '')) * qty).toFixed(2));
        if (!isNaN(cmpPack) && compareEl) compareEl.textContent  = '$' + (cmpPack * qty).toFixed(2);
      }
    }
  }

  /* ── Update bundle card pad count labels by active size ──────── */
  function updateBundlePadLabels() {
    const activeSize = $('.js-fp-size.is-active');
    const padCount   = activeSize ? parseInt(activeSize.getAttribute('data-fp-pad-count'), 10) : 0;
    if (!padCount) return;

    $$('.js-fp-bundle-btn').forEach((btn) => {
      const qty   = parseInt(btn.getAttribute('data-fp-qty'), 10) || 1;
      const label = btn.querySelector('.js-fp-bundle-qty-label');
      if (label) label.textContent = (padCount * qty) + ' Pads';
    });
  }

  /* ── Sync sticky mobile bar price ────────────────────────────── */
  function syncStickyBar() {
    const priceEl    = $('.js-fp-price');
    const isSub      = !!$('.js-fp-sub-option.is-active[data-fp-sub="subscribe"]');
    const stickyPrice = $('.js-fp-sticky-price');
    const stickyFreq  = $('.js-fp-sticky-freq');
    if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
    if (stickyFreq) stickyFreq.textContent = isSub ? '/ month' : '';
  }

  /* ── Update all bundle card inner price spans ─────────────────── */
  function updateAllBundleCardPrices() {
    const isSub      = !!$('.js-fp-sub-option.is-active[data-fp-sub="subscribe"]');
    const activeSub  = $('.js-fp-sub-option.is-active');
    const perPackPrice   = activeSub ? activeSub.getAttribute('data-fp-price')   : '';
    const perPackCompare = activeSub ? activeSub.getAttribute('data-fp-compare') : '';
    const perPackNum = parseFloat((perPackPrice   || '').replace(/[^0-9.]/g, ''));
    const perPackCmp = parseFloat((perPackCompare || '').replace(/[^0-9.]/g, ''));

    $$('.js-fp-bundle-btn').forEach((btn) => {
      const qty         = parseInt(btn.getAttribute('data-fp-qty'), 10) || 1;
      const priceSpan   = btn.querySelector('.ocbon-fp__bundle-price');
      const compareSpan = btn.querySelector('.ocbon-fp__bundle-compare');
      if (!priceSpan && !compareSpan) return;

      if (qty === 1) {
        // Single pack — mirror the active per-pack price from the toggle
        if (priceSpan)   priceSpan.textContent   = perPackPrice;
        if (compareSpan) compareSpan.textContent = perPackCompare;
      } else if (isSub) {
        // Multi-pack subscribe — use the pre-set subscribe bundle total on the button
        if (priceSpan)   priceSpan.textContent   = btn.getAttribute('data-fp-price');
        if (compareSpan) compareSpan.textContent = btn.getAttribute('data-fp-compare');
      } else {
        // Multi-pack one-time — use pre-set one-time bundle price if available, else multiply per-pack
        const oncePrice = btn.getAttribute('data-fp-price-once');
        if (priceSpan)   priceSpan.textContent   = oncePrice || ('$' + (perPackNum * qty).toFixed(2));
        if (compareSpan && !isNaN(perPackCmp)) compareSpan.textContent = '$' + (perPackCmp * qty).toFixed(2);
      }
    });

    // Keep sticky bar in sync with whatever price is now showing
    syncStickyBar();
  }

  function initBundleSelector() {
    const btns      = $$('.js-fp-bundle-btn');
    const nativeQty = $('.js-fp-native-qty');
    const atcText   = $('.js-fp-atc-text');
    if (!btns.length) return;

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        btns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const qty = parseInt(btn.getAttribute('data-fp-qty'), 10) || 1;
        if (nativeQty) nativeQty.value = qty;

        // ATC text is owned by the subscribe toggle — don't override it here
        updatePriceForBundle(btn);
        updateAllBundleCardPrices();
      });
    });
  }

  /* ── Bundle countdown timer ───────────────────────────────────── */
  function initBundleTimer() {
    const display = $('.js-fp-timer-display');
    if (!display) return;

    // 15-minute countdown, resets on page load
    let total = 15 * 60;
    const tick = () => {
      if (total <= 0) { total = 15 * 60; }
      const m = String(Math.floor(total / 60)).padStart(2, '0');
      const s = String(total % 60).padStart(2, '0');
      display.textContent = m + ':' + s;
      total--;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ── Social video play/pause ──────────────────────────────────── */
  function initSocialVideos() {
    const allVideos = $$('.js-fp-social-video');

    // Seek to first frame so browsers show a thumbnail
    allVideos.forEach((v) => {
      v.addEventListener('loadedmetadata', () => { v.currentTime = 0.001; }, { once: true });
    });

    $$('.js-fp-play-btn').forEach((btn) => {
      const wrap  = btn.closest('.ocbon-fp__video-wrap');
      const video = wrap ? wrap.querySelector('.js-fp-social-video') : null;
      if (!video) return;

      btn.addEventListener('click', () => {
        if (video.paused) {
          // Pause + reset all other videos
          allVideos.forEach((v) => {
            if (v !== video) {
              v.pause();
              v.currentTime = 0.001;
              const ob = v.closest('.ocbon-fp__video-wrap').querySelector('.js-fp-play-btn');
              if (ob) ob.classList.remove('is-playing');
            }
          });
          video.play();
          btn.classList.add('is-playing');
        } else {
          video.pause();
          btn.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', () => btn.classList.remove('is-playing'));
    });
  }

  /* ── LP Cart Drawer ───────────────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  async function openLpCartDrawer() {
    const drawer   = $('.js-fp-cart-drawer');
    const itemsEl  = $('.js-fp-cart-items');
    const footerEl = $('.js-fp-cart-footer');
    const totalEl  = $('.js-fp-cart-total');
    if (!drawer) return;

    // Show drawer immediately with a loading state
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (itemsEl) itemsEl.innerHTML = '<div class="ocbon-fp__cart-empty">Loading…</div>';

    try {
      const res  = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();

      // Update all cart count badges
      $$('.js-cart-count, .cart-count, [data-cart-count]').forEach((el) => {
        el.textContent = String(cart.item_count);
      });

      if (!cart.item_count) {
        if (itemsEl) itemsEl.innerHTML = '<div class="ocbon-fp__cart-empty">Your cart is empty.</div>';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      const html = cart.items.map((item) => `
        <div class="ocbon-fp__cart-item">
          <img class="ocbon-fp__cart-item-img"
               src="${item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_120x120$1$2') : ''}"
               alt="${item.product_title}" loading="lazy">
          <div class="ocbon-fp__cart-item-info">
            <div class="ocbon-fp__cart-item-name">${item.product_title}</div>
            <div class="ocbon-fp__cart-item-meta">
              ${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}
              ${item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : 'One-time purchase'}
            </div>
            <div class="ocbon-fp__cart-item-row">
              <div class="ocbon-fp__cart-stepper">
                <button type="button" class="ocbon-fp__cart-qty-btn js-fp-cart-qty"
                        data-key="${item.key}" data-qty="${item.quantity - 1}"
                        ${item.quantity <= 1 ? 'disabled' : ''}>−</button>
                <span class="ocbon-fp__cart-qty-val">${item.quantity}</span>
                <button type="button" class="ocbon-fp__cart-qty-btn js-fp-cart-qty"
                        data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>
              <div class="ocbon-fp__cart-item-price">${formatMoney(item.final_line_price)}</div>
              <button type="button" class="ocbon-fp__cart-remove js-fp-cart-qty"
                      data-key="${item.key}" data-qty="0">Remove</button>
            </div>
          </div>
        </div>
      `).join('');

      if (itemsEl) itemsEl.innerHTML = html;
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      if (footerEl) footerEl.style.display = '';
    } catch (err) {
      console.error('[ocbon-fp] cart drawer error:', err);
      if (itemsEl) itemsEl.innerHTML = '<div class="ocbon-fp__cart-empty">Could not load cart.</div>';
    }
  }

  function closeLpCartDrawer() {
    const drawer = $('.js-fp-cart-drawer');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function updateCartQty(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) throw new Error('Cart change failed: ' + res.status);
      openLpCartDrawer();
    } catch (err) {
      console.error('[ocbon-fp] cart change error:', err);
    }
  }

  function initLpCartDrawer() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.js-fp-cart-close') || e.target.closest('.js-fp-cart-overlay')) {
        closeLpCartDrawer();
      }

      const qtyBtn = e.target.closest('.js-fp-cart-qty');
      if (qtyBtn) {
        const key = qtyBtn.getAttribute('data-key');
        const qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        updateCartQty(key, qty);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeLpCartDrawer();
    });
  }

  /* ── Native form ATC intercept ───────────────────────────────── */
  function initNativeFormIntercept() {
    const form = $('.js-fp-native-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('button[type="submit"]');
      const btnText   = submitBtn ? submitBtn.querySelector('.js-fp-atc-text') : null;
      const origText  = btnText ? btnText.textContent : null;

      if (submitBtn) { submitBtn.disabled = true; }
      if (btnText)   { btnText.textContent = 'Adding…'; }

      try {
        const formData = new FormData(form);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (!res.ok) throw new Error('Cart add failed: ' + res.status);

        // Update cart count badges
        try {
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            $$('.js-cart-count, .cart-count, [data-cart-count]').forEach((el) => {
              el.textContent = String(cart.item_count);
            });
          }
        } catch (_) { /* non-blocking */ }

        // Open LP cart drawer
        openLpCartDrawer();

        document.dispatchEvent(new CustomEvent('ocbon:fp:cart:added'));
      } catch (err) {
        console.error('[ocbon-fp] ATC error:', err);
        alert('Something went wrong. Please try again.');
      } finally {
        if (submitBtn) { submitBtn.disabled = false; }
        if (btnText && origText) { btnText.textContent = origText; }
      }
    });
  }

  /* ── Chem card expand/collapse ────────────────────────────────── */
  function initChemExpand() {
    $$('.js-fp-chem-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.ocbon-fp__chem-card');
        const isExpanded = card.classList.toggle('is-expanded');
        btn.textContent = isExpanded ? 'Show less −' : 'Read more +';
        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    });
  }

  /* ── Cert expand/collapse ─────────────────────────────────────── */
  function initCertExpand() {
    $$('.js-fp-cert-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.ocbon-fp__cert-card');
        const isExpanded = card.classList.toggle('is-expanded');
        btn.textContent = isExpanded ? 'Show less −' : 'Read more +';
      });
    });
  }

  /* ── FAQ accordion ────────────────────────────────────────────── */
  function initFaq() {
    const items = $$('.js-fp-faq-item');
    items.forEach((item) => {
      const q = $('.js-fp-faq-q', item);
      if (!q) return;
      q.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-open');
        items.forEach((other) => {
          other.classList.remove('is-open');
          const oq = $('.js-fp-faq-q', other);
          if (oq) oq.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Smooth scroll ────────────────────────────────────────────── */
  function initSmoothScroll() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href === '#') return;

      // Check if it's an anchor for our sections
      const target = $('[data-ocbon-anchor-target="' + href.slice(1) + '"]') || $(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ── Scroll reveal ────────────────────────────────────────────── */
  function initReveal() {
    const els = $$('.ocbon-fp__reveal');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    els.forEach((el) => observer.observe(el));
  }

  /* ── Mobile sticky bar ────────────────────────────────────────── */
  function initStickyBar() {
    const bar = $('.js-fp-sticky-bar');
    if (!bar) return;
    bar.classList.add('is-visible');
    bar.removeAttribute('aria-hidden');
  }

  /* ── Shared carousel factory ──────────────────────────────────── */
  function makeCarousel(track, prevBtn, nextBtn, dotsWrap, dotClass) {
    if (!track) return;
    const cards = Array.from(track.children);
    if (!cards.length) return;

    function perView() {
      if (window.innerWidth >= 960) return 3;
      if (window.innerWidth >= 600) return 2;
      return 1;
    }
    function cardStep() { return (cards[0] ? cards[0].offsetWidth : 0) + 20; }
    function maxIndex() { return Math.max(0, cards.length - perView()); }
    function currentIndex() {
      const step = cardStep();
      return step > 0 ? Math.round(track.scrollLeft / step) : 0;
    }
    function scrollTo(index) {
      const clamped = Math.max(0, Math.min(index, maxIndex()));
      track.scrollTo({ left: clamped * cardStep(), behavior: 'smooth' });
    }
    function updateDots() {
      if (!dotsWrap) return;
      const idx = Math.min(currentIndex(), maxIndex());
      $$(`.${dotClass}`, dotsWrap).forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
    }
    function updateArrows() {
      const idx = currentIndex();
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= maxIndex();
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i <= maxIndex(); i++) {
        const dot = document.createElement('button');
        dot.className = `${dotClass} js-fp-carousel-dot`;
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dot.addEventListener('click', () => scrollTo(i));
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => scrollTo(currentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollTo(currentIndex() + 1));
    track.addEventListener('scroll', () => { updateDots(); updateArrows(); }, { passive: true });

    let touchStartX = 0;
    track.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) scrollTo(currentIndex() + (diff > 0 ? 1 : -1));
    }, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { buildDots(); scrollTo(0); }, 200);
    });

    buildDots();
    updateArrows();
  }

  function initReviewCarousel() {
    makeCarousel(
      $('.js-fp-rev-track'), $('.js-fp-rev-prev'), $('.js-fp-rev-next'),
      $('.js-fp-rev-dots'), 'ocbon-fp__rev-dot'
    );
  }

  function initSocialCarousel() {
    makeCarousel(
      $('.js-fp-social-track'), $('.js-fp-social-prev'), $('.js-fp-social-next'),
      $('.js-fp-social-dots'), 'ocbon-fp__social-dot'
    );
  }

  /* ── Free Trial product picker ───────────────────────────────── */
  function initFreeTrialPicker() {
    const section = $('.ocbon-fp-freetrial-section');
    if (!section) return;

    const products    = $$('.js-ft-product', section);
    const ctaBtn      = $('.js-ft-cta', section);
    const ctaText     = $('.js-ft-cta-text', section);
    const countEl     = $('.js-ft-count', section);
    const counterFill = $('.js-ft-counter-fill', section);
    const mainImg     = $('.js-ft-main-img', section);
    const thumbs      = $$('.js-ft-thumb', section);

    if (!products.length || !ctaBtn) return;

    const MODE         = ctaBtn.getAttribute('data-ft-mode') || 'max'; // 'max' or 'min'
    const LIMIT        = parseInt(ctaBtn.getAttribute('data-ft-limit') || '3', 10);
    const HAS_LIMIT    = LIMIT > 0;
    const quantities   = new Map(); // variantId → qty (only contains selected variants)
    const discountCode = ctaBtn.getAttribute('data-ft-discount') || 'FIRSTFREE';
    const ctaBaseText  = ctaBtn.getAttribute('data-ft-cta-active-text') || 'Claim My Order';

    var wantsSubscription = true; // default: subscribe
    var toggleBtns = $$('.js-ft-toggle-btn', section);
    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        toggleBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        wantsSubscription = btn.getAttribute('data-ft-plan') === 'subscribe';
        var subEl = section.querySelector('.ocbon-fp__urgency-sub');
        var oneEl = section.querySelector('.ocbon-fp__urgency-onetime');
        if (subEl) subEl.style.display = wantsSubscription ? '' : 'none';
        if (oneEl) oneEl.style.display = wantsSubscription ? 'none' : '';
      });
    });

    function getTotal() {
      let t = 0;
      quantities.forEach(function(q) { t += q; });
      return t;
    }

    function swapImg(url) {
      if (!mainImg || !url) return;
      mainImg.classList.add('is-fading');
      setTimeout(function() {
        mainImg.src = url;
        mainImg.classList.remove('is-fading');
      }, 180);
    }

    function syncThumbActive(url) {
      thumbs.forEach(function(t) {
        t.classList.toggle('is-active', t.getAttribute('data-fp-img') === url);
      });
    }

    function calcPriceTotal() {
      var discounted = 0, original = 0;
      quantities.forEach(function(qty, variantId) {
        products.forEach(function(b) {
          if (b.getAttribute('data-ft-variant') === variantId) {
            discounted += parseFloat(b.getAttribute('data-ft-price') || '0') * qty;
            original   += parseFloat(b.getAttribute('data-ft-original-price') || '0') * qty;
          }
        });
      });
      return { discounted: discounted, original: original, savings: original - discounted };
    }

    function updateTotalEl(prices) {
      var totalWrap   = section.querySelector('.js-ft-total');
      var totalPrice  = section.querySelector('.js-ft-total-price');
      var savingsEl   = section.querySelector('.js-ft-savings');
      if (!totalWrap) return;
      if (prices.discounted > 0) {
        if (totalPrice) totalPrice.textContent = '$' + prices.discounted.toFixed(2);
        if (savingsEl)  savingsEl.textContent  = prices.savings > 0.01 ? 'You save $' + prices.savings.toFixed(2) : '';
        totalWrap.style.display = 'block';
      } else {
        totalWrap.style.display = 'none';
      }
    }

    function update() {
      var total = getTotal();

      if (MODE === 'max') {
        // ── MAX mode: free trial — cap at LIMIT, CTA unlocks at ≥1 ─────────────
        if (countEl) countEl.textContent = total;
        if (counterFill) {
          counterFill.style.width = (total / LIMIT * 100) + '%';
          counterFill.classList.remove('is-ready');
        }

        var minStatus = section.querySelector('.js-ft-min-status');
        if (minStatus) {
          minStatus.textContent = HAS_LIMIT ? 'max ' + LIMIT : '';
          minStatus.style.color = '';
        }

        updateTotalEl(calcPriceTotal());

        if (total === 0) {
          ctaBtn.disabled = true;
          if (ctaText) ctaText.textContent = 'Select at least 1 product';
        } else {
          ctaBtn.disabled = false;
          if (ctaText) ctaText.textContent = ctaBaseText;
        }

        products.forEach(function(btn) {
          var id         = btn.getAttribute('data-ft-variant');
          var qty        = quantities.get(id) || 0;
          var isSelected = qty > 0;
          var atMax      = HAS_LIMIT && total >= LIMIT && !isSelected;

          btn.classList.toggle('is-selected', isSelected);
          btn.classList.toggle('is-disabled', atMax);

          var qtyEl   = btn.querySelector('.js-ft-qty');
          var numEl   = btn.querySelector('.js-ft-qty-num');
          var plusBtn = btn.querySelector('.js-ft-qty-plus');

          if (qtyEl)   qtyEl.style.display = isSelected ? 'flex' : 'none';
          if (numEl)   numEl.textContent   = qty;
          if (plusBtn) plusBtn.classList.toggle('is-at-max', HAS_LIMIT && total >= LIMIT);
        });

      } else {
        // ── MIN mode: 50% off — CTA unlocks at ≥LIMIT, no card disabling ───────
        var remaining = Math.max(0, LIMIT - total);
        var ready     = total >= LIMIT;

        if (countEl) countEl.textContent = total;
        if (counterFill) {
          counterFill.style.width = Math.min(total / LIMIT * 100, 100) + '%';
          counterFill.classList.toggle('is-ready', ready);
        }

        var minStatus = section.querySelector('.js-ft-min-status');
        if (minStatus) {
          if (ready) {
            minStatus.textContent = '✓ Ready!';
            minStatus.style.color = '#2E7D6A';
          } else {
            minStatus.textContent = 'add ' + remaining + ' more to continue';
            minStatus.style.color = '';
          }
        }

        updateTotalEl(calcPriceTotal());

        if (!ready) {
          ctaBtn.disabled = true;
          if (ctaText) ctaText.textContent = total === 0
            ? 'Select at least ' + LIMIT + ' products'
            : 'Add ' + remaining + ' more product' + (remaining > 1 ? 's' : '') + ' to continue';
        } else {
          ctaBtn.disabled = false;
          if (ctaText) ctaText.textContent = ctaBaseText;
        }

        products.forEach(function(btn) {
          var id         = btn.getAttribute('data-ft-variant');
          var qty        = quantities.get(id) || 0;
          var isSelected = qty > 0;

          btn.classList.toggle('is-selected', isSelected);
          btn.classList.remove('is-disabled');

          var qtyEl   = btn.querySelector('.js-ft-qty');
          var numEl   = btn.querySelector('.js-ft-qty-num');
          var plusBtn = btn.querySelector('.js-ft-qty-plus');

          if (qtyEl)   qtyEl.style.display = isSelected ? 'flex' : 'none';
          if (numEl)   numEl.textContent   = qty;
          if (plusBtn) plusBtn.classList.toggle('is-at-max', total >= 10); // soft cap at 10
        });
      }
    }

    // Product card click — toggle selection
    products.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        // Stepper buttons handle their own logic — don't re-process here
        if (e.target.closest && e.target.closest('.js-ft-qty')) return;
        if (btn.classList.contains('is-disabled')) return;

        var variantId = btn.getAttribute('data-ft-variant');
        var imgUrl    = btn.getAttribute('data-ft-img');

        if (quantities.has(variantId)) {
          quantities.delete(variantId);
        } else {
          quantities.set(variantId, 1);
          if (imgUrl) { swapImg(imgUrl); syncThumbActive(imgUrl); }
        }

        update();
      });
    });

    // Qty stepper minus / plus buttons
    products.forEach(function(btn) {
      var variantId = btn.getAttribute('data-ft-variant');
      var minusBtn  = btn.querySelector('.js-ft-qty-minus');
      var plusBtn   = btn.querySelector('.js-ft-qty-plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var current = quantities.get(variantId) || 0;
          if (current <= 1) {
            quantities.delete(variantId); // deselect when qty reaches 0
          } else {
            quantities.set(variantId, current - 1);
          }
          update();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var cap = MODE === 'max' ? (HAS_LIMIT ? LIMIT : Infinity) : 10; // max mode: cap at LIMIT (or none); min mode: soft cap at 10
          if (getTotal() >= cap) return;
          var current = quantities.get(variantId) || 0;
          quantities.set(variantId, current + 1);
          update();
        });
      }
    });

    // Gallery thumb click (independent of product cards)
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var url = thumb.getAttribute('data-fp-img');
        swapImg(url);
        syncThumbActive(url);
      });
    });

    // CTA — add selected variants with their quantities as subscription items
    ctaBtn.addEventListener('click', async function() {
      if (getTotal() === 0) return;

      var sellingPlan  = ctaBtn.getAttribute('data-ft-selling-plan') || '';
      var originalText = ctaText ? ctaText.textContent : '';

      ctaBtn.disabled = true;
      if (ctaText) ctaText.textContent = 'Adding to cart…';

      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        for (var [variantId, qty] of quantities) {
          var fd = new FormData();
          fd.append('id', variantId);
          fd.append('quantity', String(qty));
          if (sellingPlan && wantsSubscription) fd.append('selling_plan', sellingPlan);

          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: fd,
          });

          if (!res.ok) throw new Error('cart/add failed for variant ' + variantId);
        }

        window.location.href = '/checkout?discount=' + encodeURIComponent(discountCode);

      } catch (err) {
        console.error('[ocbon-ft] ATC error:', err);
        ctaBtn.disabled = false;
        if (ctaText) ctaText.textContent = originalText;
      }
    });

    update();
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  function init() {
    initSubscribeToggle();
    initGallery();
    initSizeSelector();
    initBundleSelector();
    updateAllBundleCardPrices(); // set card spans to match default active toggle
    updateBundlePadLabels();     // set pad count labels to match default active size
    initBundleTimer();
    initLpCartDrawer();
    initNativeFormIntercept();
    initSocialVideos();
    initStickyBar();
    initChemExpand();
    initCertExpand();
    initFaq();
    initSmoothScroll();
    initReveal();
    initReviewCarousel();
    initSocialCarousel();
    initFreeTrialPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
